import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HelpModule } from '../../Help-Tooltip/help.module';
import { AceIconModule } from '../Icon/icon.module';
import { AceButtonComponent } from './button.component';

@NgModule({
    imports: [CommonModule, AceIconModule, HelpModule, AceButtonComponent],
    exports: [AceButtonComponent],
})
export class AceButtonModule {}
